export default __webpack_public_path__ + "static/media/sabun-batang.f4e6ea15.png";